import React from "react";
// i18n
import { useTranslation } from "react-i18next";
import { languageOptions } from "@config/i18n/languageOptions";
// UI
import { Select } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
// styles
import clsx from "clsx";
import cx from "./language_select.module.css";
// types
import type { MightierSupportedLanguage } from "@typings/mightierApiTypes";

/**
 * doesn't have callbacks set up. Meant to be used with mantine form.getInputProps
 */
export const LanguageSelectInput = Select.withProps({
  allowDeselect: false,
  rightSection: (
    <IconChevronDown strokeWidth={2.4} style={{ height: 30, width: 30 }} />
  ),
  classNames: {
    root: cx["select-root"],
    input: cx["select-input"],
    label: clsx(cx["smaller-header"], cx["select-label"]),
    section: cx["select-section"],
    dropdown: cx["native-scrollable-dropdown"],
  },
  data: languageOptions,
  defaultValue: "en",
  "data-testid": "language-select",
  withScrollArea: false,
});

/**
 * Standalone select input intended to be used OUTSIDE of a form
 */

interface LanguageSelectStandaloneProps {
  includeLabel?: boolean;
}

export const LanguageSelectStandalone =
  React.memo<LanguageSelectStandaloneProps>((props) => {
    const { includeLabel = true } = props;

    const { t, i18n } = useTranslation();

    return (
      <LanguageSelectInput
        value={(i18n.resolvedLanguage ?? "en") as MightierSupportedLanguage}
        onChange={(newVal) => {
          i18n.changeLanguage(newVal as MightierSupportedLanguage);
        }}
        label={includeLabel ? t("startPage.inputs.selectLanguage") : undefined}
      />
    );
  });

LanguageSelectStandalone.displayName = "LanguageSelect";
